import actions from "./actions";

const initState = {
  loading: false,
  message: null,
  buttonLoading: false,
  error: null,
  serviceData: {},
  totalData: null,
  show: false,
};

export default function serviceReducer(state = initState, action) {
  switch (action.type) {
    case actions.GET_SERVICE_DATA:
      return {
        ...state,
        loading: true,
      };
    case actions.GET_SERVICE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        serviceData: action.payload.data,
        totalData: action.payload.totalDat,
      };
    case actions.GET_SERVICE_DATA_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case actions.OPEN_SERVICE_FORM:
      return {
        ...state,
        show: true,
      };

    case actions.SERVICE_RESET:
      return {
        ...state,
        show: false,
      };

    case actions.DELETE_SERVICE:
      return {
        ...state,
        buttonLoading: true,
      };
    case actions.DELETE_SERVICE_SUCCESS:
      return {
        ...state,
        buttonLoading: false,
        // message: action.payload
        message: action.payload.message,
      };
    case actions.DELETE_SERVICE_FAILED:
      return {
        ...state,
        buttonLoading: false,
        show: false,
        error: action.payload.error,
      };

    case actions.SERVICE_RESET_MESSAGE:
      return {
        ...state,
        loading: false,
        message: null,
        error: null,
        show: false,
      };
      case actions.ADD_SERVICE:
        return {
          ...state,
  
          buttonLoading: true,
        };
      case actions.ADD_SERVICE_SUCCESS:
        return {
          ...state,
          show: false,
          buttonLoading: false,
          message: 'Service added successfully'
        };
      case actions.ADD_SERVICE_FAILED:
        return {
          ...state,
          buttonLoading: false,
          show: false,
          error: action.payload.error,
        };
        case actions.OPEN_SERVICE_FORM:
          return {
            ...state,
            show: true,
          };
          case actions.SERVICE_RESET:
            return {
              ...state,
              show: false,
            };           
             
    default:
      return state;
  }
}
